// impersonation
export const BOOTSTRAP_IMPERSONATION = "bootstrapImpersonation";

// account
export const LOGIN = "login";
export const LOGIN_OAUTH = "loginOAuth";
export const SIGNUP = "signup";
export const SIGNUP_OAUTH = "signupOAuth";
export const LOGOUT = "logout";
export const UPDATE_ACCOUNT = "updateAccount";
export const FORGOT_PASSWORD = "forgotPassword";
export const RESET_PASSWORD = "resetPassword";
export const RESET_PASSWORD_AUTHED = "resetPasswordAuthed";
export const SET_PASSWORD_AND_VERIFY = "resetPasswordAndVerify";
export const REQUEST_SET_PASSWORD_AND_VERIFY = "requestSetPasswordAndVerify";
export const GET_AUTH_ACCOUNT = "getAuthAccount";
export const REQUEST_EMAIL_VERIFICATION = "requestEmailVerification";
export const VERIFY_EMAIL = "verifyEmail";
export const CLEAR_ACCOUNT_ISLOADING = "clearAccountIsLoading";

// mfa
export const VERIFY_MFA = "verifyMfa";

// organization
export const REGISTER_ORGANIZATION = "registerOrganization";
export const SIGNUP_ORGANIZATION = "signupOrganization";
export const GET_ORGANIZATIONS = "getOrganizations";
export const GET_ORGANIZATION = "getOrganization";
export const EDIT_ORGANIZATION = "editOrganization";
export const DELETE_ORGANIZATION = "deleteOrganization";
export const CLEAR_ORGANIZATION_ISLOADING = "clearOrganizationIsLoading";

// users
export const GET_USERS = "getUsers";
export const GET_USER = "getUser";
export const GET_USER_STATS = "getUserStats";
export const REGISTER_USER = "registerUser";
export const EDIT_USER = "editUser";
export const TOGGLE_USER_IS_ACTIVE = "toggleUserIsActive";
export const RECOVER_USER_ACCOUNT = "recoverUserAccount";
export const DELETE_USER = "deleteUser";
export const CLEAR_USERS_ISLOADING = "clearUsersIsLoading";

// contact
export const REGISTER_CONTACT = "registerContact";
export const IMPORT_CONTACT = "importContact";
export const GET_CONTACT = "getContact";
export const GET_CONTACTS = "getContacts";
export const EDIT_CONTACT = "editContact";
export const ADD_CONTACT_PHONE_NUMBER = "addContactPhoneNumber";
export const EDIT_CONTACT_PHONE_NUMBER = "editContactPhoneNumber";
export const DELETE_CONTACT_PHONE_NUMBER = "deleteContactPhoneNumber";
export const DELETE_CONTACT = "deleteContact";
export const ASSIGN_REP_TO_CONTACTS = "assignRepToContacts";
export const CLEAR_CONTACT_ISLOADING = "clearContactIsLoading";

// note
export const REGISTER_NOTE = "registerNote";
export const GET_NOTES = "getNotes";
export const EDIT_NOTE = "editNote";
export const DELETE_NOTE = "deleteNote";
export const CLEAR_NOTE_ISLOADING = "clearNoteIsLoading";

// tag
export const REGISTER_TAG = "registerTag";
export const GET_TAGS = "getTags";
export const EDIT_TAG = "editTag";
export const DELETE_TAG = "deleteTag";
export const CLEAR_TAG_ISLOADING = "clearTagIsLoading";

// contact_tag
export const REGISTER_CONTACT_TAG = "registerContactTag";
export const GET_CONTACT_TAGS = "getContactTags";
export const EDIT_CONTACT_TAG = "editContactTag";
export const DELETE_CONTACT_TAG = "deleteContactTag";
export const CLEAR_CONTACT_TAG_ISLOADING = "clearContactTagIsLoading";

// company
export const REGISTER_COMPANY = "registerCompany";
export const GET_COMPANY = "getCompany";
export const GET_COMPANIES = "getCompanies";
export const EDIT_COMPANY = "editCompany";
export const DELETE_COMPANY = "deleteCompany";
export const ASSIGN_REP_TO_COMPANIES = "assignRepToCompanies";
export const CLEAR_COMPANY_ISLOADING = "clearCompanyIsLoading";

// bucket
export const REGISTER_BUCKET = "registerBucket";
export const GET_BUCKET = "getBucket";
export const GET_BUCKETS = "getBuckets";
export const GET_BUCKET_STATS = "getBucketStats";
export const GET_BUCKET_COUNTS = "getBucketCounts";
export const EDIT_BUCKET = "editBucket";
export const DELETE_BUCKET = "deleteBucket";
export const BULK_DELETE_BUCKETS = "bulkDeleteBuckets";
export const CLEAR_BUCKET_ISLOADING = "clearBucketIsLoading";

// bucket_option
export const REGISTER_BUCKET_OPTION = "registerBucketOption";
export const GET_BUCKET_OPTION = "getBucketOption";
export const GET_BUCKET_OPTIONS = "getBucketOptions";
export const EDIT_BUCKET_OPTION = "editBucketOption";
export const DELETE_BUCKET_OPTION = "deleteBucketOption";
export const CLEAR_BUCKET_OPTION_ISLOADING = "clearBucketOptionIsLoading";

// organization_setting
export const REGISTER_ORGANIZATION_SETTING = "registerOrganizationSetting";
export const GET_ORGANIZATION_SETTING = "getOrganizationSetting";
export const GET_ORGANIZATION_SETTINGS = "getOrganizationSettings";
export const EDIT_ORGANIZATION_SETTING = "editOrganizationSetting";
export const DELETE_ORGANIZATION_SETTING = "deleteOrganizationSetting";
export const CLEAR_ORGANIZATION_SETTING_ISLOADING = "clearOrganizationSettingIsLoading";

// opportunity
export const REGISTER_OPPORTUNITY = "registerOpportunity";
export const GET_OPPORTUNITY = "getOpportunity";
export const GET_OPPORTUNITIES = "getOpportunities";
export const EDIT_OPPORTUNITY = "editOpportunity";
export const MOVE_OPPORTUNITY = "moveOpportunity";
export const DELETE_OPPORTUNITY = "deleteOpportunity";
export const CLEAR_OPPORTUNITY_ISLOADING = "clearOpportunityIsLoading";

// opportunity_stage
export const REGISTER_OPPORTUNITY_STAGE = "registerOpportunityStage";
export const GET_OPPORTUNITY_STAGE = "getOpportunityStage";
export const GET_OPPORTUNITY_STAGES = "getOpportunityStages";
export const EDIT_OPPORTUNITY_STAGE = "editOpportunityStage";
export const DELETE_OPPORTUNITY_STAGE = "deleteOpportunityStage";
export const CLEAR_OPPORTUNITY_STAGE_ISLOADING = "clearOpportunityStageIsLoading";

// opportunity_contact
export const REGISTER_OPPORTUNITY_CONTACT = "registerOpportunityContact";
export const GET_OPPORTUNITY_CONTACT = "getOpportunityContact";
export const GET_OPPORTUNITY_CONTACTS = "getOpportunityContacts";
export const EDIT_OPPORTUNITY_CONTACT = "editOpportunityContact";
export const DELETE_OPPORTUNITY_CONTACT = "deleteOpportunityContact";
export const CLEAR_OPPORTUNITY_CONTACT_ISLOADING = "clearOpportunityContactIsLoading";

// integration
export const CONNECT_INTEGRATION = "connectIntegration";
export const DISCONNECT_INTEGRATION = "disconnectIntegration";
export const REGISTER_INTEGRATION = "registerIntegration";
export const GET_INTEGRATION = "getIntegration";
export const GET_INTEGRATIONS = "getIntegrations";
export const EDIT_INTEGRATION = "editIntegration";
export const DELETE_INTEGRATION = "deleteIntegration";
export const CLEAR_INTEGRATION_ISLOADING = "clearIntegrationIsLoading";

// meeting
export const CONNECT_MEETING = "connectMeeting";
export const REGISTER_MEETING = "registerMeeting";
export const GENERATE_MEETING_LINK = "registerMeetingLink";
export const GET_MEETING = "getMeeting";
export const GET_MEETINGS = "getMeetings";
export const GET_MEETING_STATS = "getMeetingStats";
export const EDIT_MEETING = "editMeeting";
export const DELETE_MEETING = "deleteMeeting";
export const CLEAR_MEETING_ISLOADING = "clearMeetingIsLoading";

// notiication
export const REGISTER_NOTIFICATION = "registerNotification";
export const GET_NOTIFICATION = "getNotification";
export const GET_NOTIFICATIONS = "getNotifications";
export const EDIT_NOTIFICATION = "editNotification";
export const MARK_NOTIFICATION_SEEN = "markNotificationSeen";
export const DELETE_NOTIFICATION = "deleteNotification";
export const CLEAR_NOTIFICATION_ISLOADING = "clearNotificationIsLoading";
export const PUSH_NOTIFICATION_POPUP_ACTION = "pushNotificationPopup";
export const CLOSE_NOTIFICATION_POPUP_ACTION = "closeNotificationPopup";
export const LOAD_MORE_NOTIFICATIONS = "loadMoreNotifications";

// template_folder
export const REGISTER_TEMPLATE_FOLDER = "registerTemplateFolder";
export const GET_TEMPLATE_FOLDER = "getTemplateFolder";
export const GET_TEMPLATE_FOLDERS = "getTemplateFolders";
export const EDIT_TEMPLATE_FOLDER = "editTemplateFolder";
export const DELETE_TEMPLATE_FOLDER = "deleteTemplateFolder";
export const CLEAR_TEMPLATE_FOLDER_ISLOADING = "clearTemplateFolderIsLoading";

// parent_template_folder
export const REGISTER_PARENT_TEMPLATE_FOLDER = "registerParentTemplateFolder";
export const GET_PARENT_TEMPLATE_FOLDER = "getParentTemplateFolder";
export const GET_PARENT_TEMPLATE_FOLDERS = "getParentTemplateFolders";
export const EDIT_PARENT_TEMPLATE_FOLDER = "editParentTemplateFolder";
export const DELETE_PARENT_TEMPLATE_FOLDER = "deleteParentTemplateFolder";
export const CLEAR_PARENT_TEMPLATE_FOLDER_ISLOADING = "clearParentTemplateFolderIsLoading";

// template
export const REGISTER_TEMPLATE = "registerTemplate";
export const GET_TEMPLATE = "getTemplate";
export const GET_TEMPLATES = "getTemplates";
export const EDIT_TEMPLATE = "editTemplate";
export const COPY_TEMPLATE = "copyTemplate";
export const POSITIVE_TEMPLATE = "positiveTemplate";
export const NEGATIVE_TEMPLATE = "negativeTemplate";
export const DELETE_TEMPLATE = "deleteTemplate";
export const CLEAR_TEMPLATE_ISLOADING = "clearTemplateIsLoading";

// fullenrich
export const REQUEST_ENRICHMENT = "requestEnrichment";
export const CLEAR_FULLENRICH_ISLOADING = "clearFullenrichIsLoading";

// reports
export const GET_ANALYTIC_REPORTS = "getAnalyticReports";
export const GET_DASHBOARD_STATS = "getDashboardStats";
export const GET_CONTACT_MOVEMENTS = "getContactMovements";
export const GET_CALL_CONNECT_RATE = "getCallConnectRate";
export const GET_MEETING_BOOKING_METRICS = "getMeetingBookingMetrics";
export const CLEAR_REPORT_ISLOADING = "clearReportIsLoading";

// bucket_journey
export const REGISTER_BUCKET_JOURNEY = "registerBucketJourney";
export const GET_BUCKET_JOURNEY = "getBucketJourney";
export const GET_BUCKET_JOURNIES = "getBucketJournies";
export const EDIT_BUCKET_JOURNEY = "editBucketJourney";
export const DELETE_BUCKET_JOURNEY = "deleteBucketJourney";
export const CLEAR_BUCKET_JOURNEY_ISLOADING = "clearBucketJourneyIsLoading";

// subscription
export const CREATE_CHECKOUT = "createCheckout";
export const GET_STRIPE_SESSION_INFO = "getStripeSessionInfo";
export const GET_ORGANIZATION_ACTIVE_SUBSCRIPTION = "getOrganizationActiveSubscription";
export const GET_ORGANIZATION_SUBSCRIPTIONS = "getOrganizationSubscriptions";
export const GET_STRIPE_BILLING_PORTAL_URL = "getStripeBillingPortalUrl";
export const CLEAR_SUBSCRIPTION_ISLOADING = "clearSubscriptionIsLoading";

// billing
export const GET_USAGE_STATS = "getUsageStats";
export const GET_USAGE_HISTORY = "getUsageHistory";
export const GET_INVOICES = "getInvoices";
export const GET_PAYMENT_METHODS = "getPaymentMethods";
export const CLEAR_BILLING_ISLOADING = "clearBillingIsLoading";
export const GET_SUBSCRIPTION_STATUS = "getSubscriptionStatus";
export const CREATE_SETUP_CHECKOUT = "createSetupCheckout";
export const START_FREE_TRIAL = "startFreeTrial";
export const GET_TRIAL_STATUS = "getTrialStatus";

// call_log
export const REGISTER_CALL_LOG = "registerCallLog";
export const GET_CALL_LOGS = "getCallLogs";
export const LOG_CALL_LOG_DETAILS = "logCallLogDetails";
export const DELETE_CALL_LOG = "deleteCallLog";
export const CLEAR_CALL_LOG_ISLOADING = "clearCallLogIsLoading";

// phone_number
export const REGISTER_PHONE_NUMBER = "registerPhoneNumber";
export const GET_PHONE_NUMBERS = "getPhoneNumbers";
export const GET_PHONE_NUMBER_ROTATIONS = "getPhoneNumberRotations";
export const DELETE_PHONE_NUMBER = "deletePhoneNumber";
export const CLEAR_PHONE_NUMBER_ISLOADING = "clearPhoneNumberIsLoading";

// call_disposition
export const GET_CALL_DISPOSITIONS = "getCallDispositions";
export const CLEAR_CALL_DISPOSITION_ISLOADING = "clearCallDispositionIsLoading";

// lead_source
export const GET_LEAD_SOURCES = "getLeadSources";
export const CLEAR_LEAD_SOURCE_ISLOADING = "clearLeadSourceIsLoading";

// activity_log
export const REGISTER_ACTIVITY_LOG = "registerActivityLog";
export const GET_ACTIVITY_LOGS = "getActivityLogs";
export const EDIT_ACTIVITY_LOG = "editActivityLog";
export const DELETE_ACTIVITY_LOG = "deleteActivityLog";
export const CLEAR_ACTIVITY_LOG_ISLOADING = "clearActivityLogIsLoading";

// search
export const GLOBAL_SEARCH = "getGlobalSearch";
export const CLEAR_SEARCH_ISLOADING = "clearSearchIsLoading";

// router_loader
export const UPDATE_ROUTER_LOADER = "updateRouterLoader";
export const CLEAR_ROUTER_LOADER = "clearRouterLoader";

// error
export const CLEAR_ERRORMSG = "clearErrorMessage";
export const UPDATE_ERRORMSG = "updateErrorMessage";
